import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      duration={2400}
      closeButton
      visibleToasts={3}
      expand={false}
      gap={8}
      offset={{ top: 14, right: 14, left: 14, bottom: 90 }}
      mobileOffset={{ top: 10, right: 10, left: 10, bottom: 78 }}
      toastOptions={{
        duration: 2600,
        classNames: {
          toast:
            "group toast pointer-events-auto rounded-md border border-border bg-card/95 text-foreground shadow-2 backdrop-blur-sm data-[swipe=move]:transition-none px-3 py-2",
          title: "text-[13px] font-semibold tracking-tight",
          description: "text-xs text-muted-foreground leading-relaxed",
          success:
            "border-success/40 bg-success/[0.08] text-foreground",
          error:
            "border-destructive/40 bg-destructive/[0.08] text-foreground",
          warning:
            "border-border bg-muted/60 text-foreground",
          info:
            "border-primary/35 bg-primary/[0.07] text-foreground",
          actionButton:
            "rounded-md bg-primary px-2.5 py-1 text-xs text-primary-foreground hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-primary/50",
          cancelButton:
            "rounded-md bg-muted px-2.5 py-1 text-xs text-muted-foreground hover:bg-muted/80",
          closeButton:
            "bg-transparent text-foreground/45 hover:text-foreground hover:bg-muted/60 rounded-md",
        },
      }}
      {...props} />
  );
}

const toast = {
  ...sonnerToast,
  error: sonnerToast.error,
  success: sonnerToast.success,
  info: sonnerToast.info,
  warning: sonnerToast.warning,
  loading: sonnerToast.loading,
  promise: sonnerToast.promise,
  custom: sonnerToast.custom,
};

export { Toaster, toast }
